















import Vue from 'vue'

export default Vue.extend({
	name: 'Home',
	data() {
		return {
			go: '',
		}
	},
	methods: {
		done: function () {
			location.href = `/q/${this.go}`
		},
	},
})
